import { Component, computed, input, output } from '@angular/core';
import { CardAccount } from '../../models/accounts.model';

@Component({
  selector: 'app-card-account-item',
  templateUrl: './card-account-item.component.html',
  styleUrls: ['./card-account-item.component.scss'],
  standalone: false,
})
export class CardAccountItemComponent {
  readonly account = input.required<CardAccount>();
  readonly onClickCreditCard = output<CardAccount>();

  readonly accountTitle = computed(() => `Best Egg...${this.account().lastFourCardNumber ?? ''}`);

  emitCreditCardClick() {
    this.onClickCreditCard.emit(this.account());
  }
}
